import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useLanguage } from '../hooks/useLanguage';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { ArrowRightIcon, ArrowLeftIcon } from 'lucide-react';
import { GovernanceGrid } from '../components/GovernanceGrid';
export function CorporateGovernancePage() {
  const {
    t,
    setLocale,
    direction
  } = useLanguage();
  const location = useLocation();
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useScrollReveal();
  const {
    ref: descRef,
    isVisible: descVisible
  } = useScrollReveal();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useScrollReveal();
  const ArrowIcon = direction === 'rtl' ? ArrowLeftIcon : ArrowRightIcon;
  useEffect(() => {
    if (location.pathname.startsWith('/ar')) {
      setLocale('ar');
    } else {
      setLocale('en');
    }
    window.scrollTo(0, 0);
  }, [location.pathname, setLocale]);
  return <div className="min-h-screen w-full bg-white text-slate-900" dir={direction} data-id="element-694">
      <Header variant="transparent-dark" data-id="element-695" />

      <main data-id="element-696">
        {/* Wrapper for hero + description */}
        <div className="relative" data-id="element-697">
          {/* 1. Hero Banner */}
          <section className="relative min-h-screen overflow-hidden" ref={heroRef} aria-label="Corporate Governance Hero" data-id="element-698">
            {/* Background Image */}
            <div className="absolute inset-0 bg-cover bg-center" role="presentation" aria-hidden="true" style={{
            backgroundImage: "url('https://cdn.magicpatterns.com/uploads/pcp9GGpyXMTUsYcLaVn4hj/corporate-governance.jpg')"
          }} data-id="element-699" />

            {/* Overlay for better text readability */}
            <div className="absolute inset-0 bg-black/20" data-id="element-700" />

            <div className="relative z-10 w-full min-h-screen flex items-center" data-id="element-701">
              <div className="container mx-auto px-6 md:px-12" data-id="element-702">
                <div className="max-w-3xl" data-id="element-703">
                  <h1 className={`text-[#061D76] font-semibold leading-[1.05] mb-10 uppercase text-[32px] md:text-[44px] lg:text-[55px] whitespace-pre-line reveal-hidden ${heroVisible ? 'animate-fade-up' : ''}`} data-id="element-704">
                    {t('corporateGovernancePage.hero.title')}
                  </h1>
                  <p className={`text-base md:text-lg text-[#061D76] mb-10 max-w-xl leading-relaxed reveal-hidden ${heroVisible ? 'animate-fade-up delay-200' : ''}`} data-id="element-705">
                    {t('corporateGovernancePage.hero.subtitle')}
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* 2. Description Section - Dark gradient with text only */}
          <section className="section-inner gradient-dark-horizontal text-white relative overflow-hidden z-[2]" ref={descRef} aria-label="Corporate Governance Overview" data-id="element-706">
            <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-707">
              <div className="max-w-5xl space-y-8" data-id="element-708">
                <p className={`text-lg md:text-xl leading-relaxed reveal-hidden ${descVisible ? 'animate-fade-up' : ''}`} data-id="element-709">
                  {t('corporateGovernancePage.description.paragraph1')}
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* 3. Governance Grid Section */}
        <GovernanceGrid data-id="element-710" />

        {/* 4. CTA Banner - Same as homepage TrustedSection */}
        <section className="relative py-24 text-white overflow-hidden" dir={direction} ref={ctaRef} aria-label="Call to Action" data-id="element-711">
          {/* Background Image */}
          <div className="absolute inset-0 bg-cover bg-center" role="presentation" aria-hidden="true" style={{
          backgroundImage: "url('https://cdn.magicpatterns.com/uploads/aNushftuwBdDBhG34PgQWF/Trusted.jpg')",
          transform: direction === 'rtl' ? 'scaleX(-1)' : 'none'
        }} data-id="element-712"></div>

          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-713">
            <div data-id="element-714">
              <h2 className={`text-4xl md:text-5xl font-bold mb-6 whitespace-pre-line reveal-hidden ${ctaVisible ? 'animate-fade-left' : ''}`} data-id="element-715">
                {t('trusted.title')}
              </h2>
              <p className={`text-white max-w-[950px] text-lg mb-8 leading-relaxed reveal-hidden ${ctaVisible ? 'animate-fade-left delay-200' : ''}`} data-id="element-716">
                {t('trusted.description')}
              </p>
              <button className={`btn-primary reveal-hidden ${ctaVisible ? 'animate-fade-up delay-400' : ''}`} data-id="element-717">
                {t('trusted.learnMore')}
                <ArrowIcon className="w-4 h-4" data-id="element-718" />
              </button>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-719" />
    </div>;
}